import type { Setting, SettingsApiResponse } from '../../context/settings-context';
import { ApiService } from '../../types/api';

export interface SettingsApiContract {
  list(): Promise<SettingsApiResponse>;
  update(setting: Setting): Promise<void>;
  updateMany(settings: Setting[]): Promise<void>;
  listShopify(siteId: string, siteEnv: string): Promise<SettingsApiResponse>;
  updateShopify(siteId: string, siteEnv: string, settings: Setting[]): Promise<void>;
}

export class SettingsApi extends ApiService implements SettingsApiContract {
  public list(): Promise<SettingsApiResponse> {
    return this.api.proxy<SettingsApiResponse>({
      method: 'GET',
      path: '/v1/settings',
    });
  }

  public update(setting: Setting): Promise<void> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/settings',
      payload: [setting],
    });
  }

  public updateMany(settings: Setting[]): Promise<void> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/settings',
      payload: settings,
    });
  }

  public listShopify(siteId: string, siteEnv: string): Promise<SettingsApiResponse> {
    return this.api.fetch<SettingsApiResponse>({
      method: 'GET',
      path: `/${encodeURIComponent(siteId)}/${encodeURIComponent(siteEnv)}/shopify/settings`,
    });
  }

  public updateShopify(siteId: string, siteEnv: string, settings: Setting[]): Promise<void> {
    return this.api.fetch({
      method: 'PATCH',
      path: `/${encodeURIComponent(siteId)}/${encodeURIComponent(siteEnv)}/shopify/settings`,
      payload: settings,
    });
  }
}
